var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocial1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7041 0.960449C6.22089 2.1555 1.47802 7.01312 0.322516 12.6169C-1.0754 19.3971 2.16724 26.3024 8.18412 29.3586C10.1706 30.3674 12.67 31.0619 14.3441 31.0697L15.2241 31.0738V25.1199V19.1661H13.5815H11.9388V17.2609V15.3556H13.5815H15.2241V13.675C15.2241 11.2613 15.6088 9.96408 16.6322 8.9255C17.8383 7.70139 20.0362 7.19912 22.2348 7.64542L22.9682 7.79427V9.43157V11.0689H21.6125C19.5348 11.0689 19.2135 11.4056 19.2135 13.5831V15.3556H21.0068H22.8004L22.6495 16.8196C22.5667 17.6245 22.4988 18.4819 22.4988 18.7248C22.4988 19.1125 22.2991 19.1661 20.8562 19.1661H19.2135V24.7627C19.2135 29.3705 19.271 30.3593 19.5383 30.3593C19.7171 30.3593 20.7466 29.9111 21.8263 29.3634C26.6816 26.9001 30 21.4064 30 15.8319C30 10.2091 26.6827 4.73923 21.7869 2.29006C18.5386 0.6649 15.1251 0.21479 11.7041 0.960449Z",
    fill: "#F04C64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial1);
export default __webpack_public_path__ + "static/media/social-1.01e324eb8f7dcb02927bfeb5ce331686.svg";
export { ForwardRef as ReactComponent };